import SgLoader from './SgLoader'

let {overlay, absolute, text, loading, ...props} = SgLoader.props

export default Object.assign({}, SgLoader, {
    props,
    data() {
        return {
            overlay: true,
            absolute: true,
            loading: false,
            text: ""
        }
    },
    methods: {
        onLoaderShow(data) {
            this.text = (data && data.loaderText) || ""
            this.loading = true
        },
        onLoaderHide(data) {
            this.loading = false
        }
    },
    created() {
        this.overlay = true
        this.absolute = true
        this.$eventBus.$on('loader:show', this.onLoaderShow)
        this.$eventBus.$on('loader:hide', this.onLoaderHide)
    },
    beforeDestroy() {
        this.$eventBus.$off('loader:show', this.onLoaderShow)
        this.$eventBus.$off('loader:hide', this.onLoaderHide)
    }
})